import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

export const MountArea = styled('div')``

export const Overlay = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-overlay;
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: ${theme.colors.overlay};
    display: flex;
    justify-content: flex-end;
    opacity: 0;
    pointer-events: none;
    transition: opacity 160ms ease;

    &[data-open='true'] {
      opacity: 1;
      pointer-events: auto;
    }
  `
)

export const Panel = styled('aside')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-panel;
    width: 100%;
    max-width: 480px;
    height: 100%;
    background: ${theme.colors.white};
    padding: ${theme.spacings.giga};
    position: relative;
    transform: translateX(100%);
    transition: transform 220ms ease;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.mega};
    overflow: auto;

    &[data-open='true'] {
      transform: translateX(0);
    }
  `
)

export const CloseButton = styled('button')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-close;
    position: absolute;
    top: 12px;
    right: 16px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 0;
    background: transparent;
    font-size: 28px;
    line-height: 1;
    color: ${theme.colors.n600};
    cursor: pointer;

    &:hover {
      color: ${theme.colors.n900};
    }
  `
)

export const Title = styled('h2')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-title;
    font-size: 20px;
    font-weight: ${theme.font.weight.bold};
    color: ${theme.colors.n900};
  `
)

export const Subtitle = styled('p')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-subtitle;
    color: ${theme.colors.n600};
    font-size: 14px;
    margin: 0 0 20px 0;
  `
)

export const RangeRow = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-range-row;
    display: flex;
    justify-content: space-between;
    color: ${theme.colors.n600};
    font-size: 12px;

    strong {
      font-size: 18px;
    }
  `
)

export const RangeWrapper = styled('div')`
  label: cashback__drawer-range-wrapper;
  position: relative;
  padding-top: 10px;
`

export const CenterValue = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-center-value;
    position: absolute;
    top: -60px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 4px;
    font-weight: 800;
    color: ${theme.colors.success};
    white-space: nowrap;
    pointer-events: none;
    z-index: 1;
    border-bottom: 2px dotted ${theme.colors.g100};
    padding-bottom: 4px;

    &::before {
      content: 'R$';
      font-size: 14px;
      font-weight: 700;
      color: ${theme.colors.success};
    }

    span {
      font-size: 28px;
      font-weight: 800;
      color: ${theme.colors.success};
      letter-spacing: -0.5px;
    }
  `
)

export const Range = styled('input')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-range;
    width: 100%;
    height: 12px;
    appearance: none;
    border-radius: 999px;
    outline: none;
    background: linear-gradient(
      to right,
      ${theme.colors.success} 0%,
      ${theme.colors.success} var(--p),
      ${theme.colors.g100} var(--p),
      ${theme.colors.g100} 100%
    );

    &::-webkit-slider-thumb {
      appearance: none;
      width: 22px;
      height: 22px;
      background: ${theme.colors.white};
      border-radius: 50%;
      border: 2px solid ${theme.colors.white};
      box-shadow: 0 0 0 4px ${theme.colors.success};
      cursor: pointer;
      margin-top: -5px;
    }

    &::-moz-range-track {
      height: 12px;
      border-radius: 999px;
      background: transparent;
    }

    &::-moz-range-progress {
      height: 12px;
      border-radius: 999px 0 0 999px;
      background: ${theme.colors.success};
    }

    &::-moz-range-thumb {
      width: 22px;
      height: 22px;
      background: ${theme.colors.white};
      border: 2px solid ${theme.colors.white};
      border-radius: 50%;
      box-shadow: 0 0 0 4px ${theme.colors.success};
      cursor: pointer;
    }
  `
)

export const PointsBubble = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-points-bubble;
    position: absolute;
    left: var(--p);
    transform: translateX(-50%);
    font-size: 22px;
    font-weight: 800;
    color: ${theme.colors.success};
    white-space: nowrap;
    pointer-events: none;

    &[data-edge='left'] {
      left: 0;
      transform: translateX(0);
    }

    &[data-edge='right'] {
      left: 100%;
      transform: translateX(-100%);
    }

    span {
      margin-left: 4px;
      font-size: 16px;
      font-weight: 700;
      color: ${theme.colors.success};
      opacity: 0.9;
    }
  `
)

export const PointsRow = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-points-row;
    display: flex;
    justify-content: space-between;
    color: ${theme.colors.n600};
    font-size: 12px;
    margin-top: 36px;

    strong {
      font-size: 18px;
    }
  `
)

export const PrimaryButton = styled('button')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-primary-btn;
    display: block;
    width: 75%;
    margin: 20px auto 0;
    height: 42px;
    background: ${theme.colors.g600};
    border: 2px solid ${theme.colors.g600};
    color: ${theme.colors.white};
    border-radius: 8px;
    font-weight: ${theme.font.weight.bold};
    font-size: 14px;
    cursor: pointer;
    transition:
      opacity 0.2s ease,
      background 0.2s ease;

    &:hover {
      background: ${theme.colors.success};
      border-color: ${theme.colors.success};
    }

    &:disabled {
      background: ${theme.colors.n100};
      border-color: ${theme.colors.n100};
      color: ${theme.colors.n400};
      cursor: not-allowed;
      opacity: 0.8;
    }
  `
)

export const HelpRow = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-help-row;
    display: flex;
    justify-content: center;
    font-size: 14px;
    margin-top: 5px;

    button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: transparent;
      border: 0;
      color: ${theme.colors.n700};
      cursor: pointer;
      height: 42px;
    }
  `
)

export const ChevronDown = styled('svg')`
  label: cashback__drawer-chevron;
  width: 18px;
  height: 18px;
`

export const FaqList = styled('div')`
  label: cashback__faq-list;
  display: grid;
  margin-bottom: 100px;
`

export const FaqAnswer = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__faq-answer;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: all 0.2s ease;
    font-size: 13px;
    color: ${theme.colors.n600};
    padding: 0;
    white-space: pre-line;
  `
)

export const FaqItem = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__faq-item;
    border-bottom: 1px solid ${theme.colors.n100};

    &[data-open='true'] ${FaqAnswer} {
      max-height: 400px;
      opacity: 1;
      padding: 8px 0 16px;
    }
  `
)

export const FaqQuestion = styled('button')(
  ({ theme }: Theme) => css`
    label: cashback__faq-question;
    width: 100%;
    background: transparent;
    border: 0;
    padding: 16px 0;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${theme.colors.n900};
    cursor: pointer;
    font-size: 14px;
  `
)

export const FaqChevron = styled('svg')(
  ({ theme }: Theme) => css`
    label: cashback__faq-chevron;
    width: 16px;
    height: 16px;
    transition: transform 0.15s ease;
    color: ${theme.colors.n600};

    &[data-open='true'] {
      transform: rotate(180deg);
    }
  `
)

export const SkeletonLine = styled('div')<{ small?: boolean }>(
  ({ theme, small }: Theme & { small?: boolean }) => css`
    label: cashback__drawer-skeleton-line;
    height: ${small ? '14px' : '18px'};
    width: ${small ? '55%' : '70%'};
    border-radius: 8px;
    background: ${theme.colors.n100};
    position: relative;
    overflow: hidden;
    margin: ${small ? '14px 0 0' : '0'};

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      animation: cashback_skeleton_shimmer 1.1s ease-in-out infinite;
    }
  `
)

export const SkeletonRange = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-skeleton-range;
    height: 12px;
    width: 100%;
    border-radius: 999px;
    background: ${theme.colors.n100};
    position: relative;
    overflow: hidden;
    margin-top: 14px;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      animation: cashback_skeleton_shimmer 1.1s ease-in-out infinite;
    }
  `
)

export const SkeletonThumb = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-skeleton-thumb;
    position: absolute;
    top: 50%;
    left: 22px;
    transform: translate(-50%, -50%);
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: ${theme.colors.white};
    box-shadow: 0 0 0 4px ${theme.colors.success};
    pointer-events: none;
  `
)

export const SkeletonCenterValue = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-skeleton-center-value;
    margin-top: 10px;
    height: 34px;
    width: 140px;
    border-radius: 10px;
    background: ${theme.colors.n100};
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      animation: cashback_skeleton_shimmer 1.1s ease-in-out infinite;
    }
  `
)

export const SkeletonRow = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-skeleton-row;
    display: flex;
    justify-content: space-between;
    margin-top: 14px;

    > div {
      height: 18px;
      width: 90px;
      border-radius: 8px;
      background: ${theme.colors.n100};
      position: relative;
      overflow: hidden;

      &::after {
        content: '';
        position: absolute;
        inset: 0;
        transform: translateX(-100%);
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.7) 50%,
          rgba(255, 255, 255, 0) 100%
        );
        animation: cashback_skeleton_shimmer 1.1s ease-in-out infinite;
      }
    }
  `
)

export const SkeletonButton = styled('div')(
  ({ theme }: Theme) => css`
    label: cashback__drawer-skeleton-button;
    width: 75%;
    height: 42px;
    border-radius: 8px;
    background: ${theme.colors.n100};
    margin: 20px auto 0;
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      animation: cashback_skeleton_shimmer 1.1s ease-in-out infinite;
    }
  `
)

export const SkeletonBlock = styled('div')`
  label: cashback__drawer-skeleton-block;
  margin-top: 24px;
  display: grid;
  gap: 14px;
  position: relative;

  ${SkeletonRange} {
    position: relative;
  }

  ${SkeletonThumb} {
    position: absolute;
    left: 22px;
    top: 64px;
  }
`

export const SkeletonKeyframes = css`
  @keyframes cashback_skeleton_shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`
